import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || "https://szcdtqgfxyqdpswlxruk.supabase.co";
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN6Y2R0cWdmeHlxZHBzd2x4cnVrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY0MzUwNjAsImV4cCI6MjA5MjAxMTA2MH0.WU1v8ZMzxJCtvgv0-xq0omlg9Ku5qagbvhglkR7q8YQ";

export const supabase = createClient(supabaseUrl, supabaseKey);
